import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'graphic-ui',
  templateUrl: 'graphic-ui.component.html',
  styleUrls: ['graphic-ui.component.sass']
})
export class GraphicUIComponent implements OnInit {

  @Input() widthGraphic;
  @Input() heightGraphic;
  @Input() public lineChartLabels: Array<any> = [];
  @Input() public lineChartData: Array<any> = [
    { data: [], label: [] }
  ];
  @Input() public lineChartOptions: any = {
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0
        }
      }]
    },
    layout: {
      padding: {
        left: 15,
        right: 15,
        top: 15,
        bottom: 15
      }
    }
  };
  @Input() public lineChartColors: Array<any> = [
    { // grey
      backgroundColor: 'rgba(0,126,202,0.2)',
      borderColor: 'rgba(0,126,202,1)',
      pointBackgroundColor: 'rgba(0,126,202,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(0,126,202,0.8)'
    },
    { // grey
      backgroundColor: 'rgba(255, 140, 0,0.2)',
      borderColor: 'rgba(255, 140, 0,1)',
      pointBackgroundColor: 'rgba(255, 140, 0,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(255, 140, 0,0.8)'
    },
    {
      backgroundColor: 'rgba(0, 250, 154,0.2)',
      borderColor: 'rgba(0, 250, 154,1)',
      pointBackgroundColor: 'rgba(0, 250, 154,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(0, 250, 154,0.8)'
    }
  ];
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';

  ngOnInit () {

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/graphic/graphic-ui.component.ts